import { routeConfig } from "@/routes/route";
import { Suspense, lazy } from "react";
import { useTranslation } from "react-i18next";

const LazyLoad = (path: string) => {
  const Comp = lazy(() => import("@BZA/" + path));
  return (
    <Suspense fallback={<></>}>
      <Comp />
    </Suspense>
  );
};

export const useCampaignRouterConfig = (): routeConfig[] => {
  const { t } = useTranslation();

  return [
    {
      path: "/ExtensionManagement",
      element: LazyLoad("Campaign/CampaignList/index"),
      name: t("Basics.LeftMenu.PromotionManagement"),
      key: "Megaphone",
      icon: "Megaphone",
    },
    {
      path: "/ExtensionManagement/importCampaign",
      element: LazyLoad("ToolCenter/campaignCenter/importCampaign"),
      name: t("Basics.LeftMenu.ImportMaterial"),
      key: "importCampaign",
      icon: "importCampaign",
      isHidden: true,
      fromPath: "/ExtensionManagement",
    },
  ];
};

export const campaignRouterMap: routeConfig[] = [
  {
    path: "/ExtensionManagement",
    element: LazyLoad("Campaign/CampaignList/index"),
    name: "推广管理",
    key: "Megaphone",
    icon: "Megaphone",
  },
  {
    path: "/ExtensionManagement/importCampaign",
    element: LazyLoad("ToolCenter/campaignCenter/importCampaign"),
    name: "导入物料",
    key: "importCampaign",
    icon: "importCampaign",
    isHidden: true,
    fromPath: "/ExtensionManagement",
  },
];
